<template>
  <el-form
    ref="addTask"
    :model="addTaskForm"
    :rules="rules"
    label-width="110px"
  >
    <el-row>
      <el-col :span="24">
        <el-form-item label="任务所属部门" :required="true">
          <el-select
            v-model="addFrom.bmbh"
            filterable
            default-first-option
            style="width: 100%"
            disabled
            placeholder="请选择关键词类型"
          >
            <el-option
              v-for="(item, index) in bmList"
              :key="index"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="任务所属条线" :required="true">
          <el-select
            v-model="addFrom.txlx"
            filterable
            default-first-option
            style="width: 100%"
            placeholder="请选择关键词类型"
          >
            <el-option
              v-for="(item, index) in ygtxoptions"
              :key="index"
              :label="item.value"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="任务类型" :required="true">
          <el-input v-model="addFrom.name"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-row>
          <el-col :span="24">
            <el-form-item label="子类" prop="title">
              <el-input v-model="addFrom.sun"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24">
        <el-form-item label="类型编号" :required="true">
          <el-input v-model="addFrom.lxbh"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="标准积分" :required="true">
          <el-input-number
            :min="1"
            :max="99999"
            maxlength="5"
            v-model="addFrom.jf"
          ></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 6 }"
            maxlength="200"
            show-word-limit
            placeholder="请输入说明"
            v-model="addFrom.bz"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import { getBmxxList, saveAddTaskType, getKeyValue } from "@/api/taskType.js";
export default {
  name: "add",
  computed: {},
  components: {},
  props: ["mxParams"],
  data() {
    return {
      addFrom: {
        lxbh: null,
        txlx: null,
        name: null,
        bz: null,
        isReview: 1,
        isMultiple: 1,
        jf: 5,
        sun: null,
        bmbh: null,
      },
      bmList: [],
      lxList: [],
      zlList: [],
      ygtxoptions: [],
      user: this.$store.state.common.user,
      parentDialog: false,
    };
  },

  created() {
    getBmxxList("0").then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
      }
    });
    getKeyValue("TXLX", "", "0").then((res) => {
      if (res.code === 0) {
        this.ygtxoptions = res.data;
      }
    });
    this.addFrom.bmbh = this.user.bmbh;
    // this.addFrom.txlx = this.user.txlxbh;
  },
  methods: {
    handleChangeRlsh(e) {
      this.addFrom.isReview = e;
    },
    handleChangeDrel(e) {
      this.addFrom.isMultiple = e;
    },
    handleAdd() {
      saveAddTaskType(this.addFrom).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.$emit("giveFather", this.parentDialog);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    giveFather() {
      this.parentDialog = false;
    },
  },
};
</script>
<style lang="less" scoped>
</style>